import { NewPageComponent } from '../../templates/new-page/new-page.component';
import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { ActivatedRoute } from '@angular/router';
import { ExtraService } from '../../core/services/extra.service';
import { DropDownComponent } from '../../layout/drop-down/drop-down.component';
import { from } from 'rxjs/observable/from';
import { NewPageList } from '../../core/models/new-page-list';
import { ListWithinList } from '../../core/models/list-within-list';
import { Constants } from '../../core/config/Constants';


@Component({
  selector: 'app-live-streaming',
  templateUrl: './live-streaming.html',
  styleUrls: ['./live-streaming.component.css'],
  providers: [ExtraService]
})
export class LiveStreamingComponent {

  public page = {
    title: "Live Streaming",
    slug: "Streaming"
  };

  constructor() {

  }

}






// WEBPACK FOOTER //
// /app/src/app/event/live-streaming/live-streaming.component.ts